import { css } from '@emotion/css';
import React from 'react';
import { Status } from '../common/Status';
import { theme } from '../../theme';
import { SearchInput } from './SearchInput';
const wrapperStyles = css({
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
});
const titleStyles = css({
    fontFamily: 'TriadeChoco Upright',
    fontSize: '36px',
    letterSpacing: '0.25px',
    textTransform: 'uppercase',
    lineHeight: '36px',
    color: theme.colors.white,
    margin: '0',
    fontWeight: 'bold',
});
const resetButtonStyles = css({
    cursor: 'pointer',
    color: theme.colors.chocoBlue,
    background: 'none',
    textTransform: 'uppercase',
    padding: '0px',
    position: 'relative',
    border: '0',
    '&:hover': {
        color: theme.colors.lightBlue,
    },
});
const flagsCountRowStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '20px',
    height: '35px',
};
const PanelHeader = ({ search, setSearch, onResetAll, localFlags, inputRef, }) => {
    const localFlagsCount = Object.keys(localFlags).length;
    return (React.createElement("div", { className: wrapperStyles },
        React.createElement("h4", { className: titleStyles }, "Toggle Feature Flags"),
        React.createElement("div", { style: flagsCountRowStyles },
            React.createElement(Status, { status: "overridden", text: `You have ${localFlagsCount} flags overridden locally.` }),
            localFlagsCount > 0 && (React.createElement("button", { type: "button", className: resetButtonStyles, onClick: onResetAll }, "Reset all"))),
        React.createElement(SearchInput, { ref: inputRef, search: search, setSearch: setSearch })));
};
export { PanelHeader };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFuZWxIZWFkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9TaWRlUGFuZWwvUGFuZWxIZWFkZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxjQUFjLENBQUM7QUFDbkMsT0FBTyxLQUFrQyxNQUFNLE9BQU8sQ0FBQztBQUV2RCxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sa0JBQWtCLENBQUM7QUFDMUMsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLGFBQWEsQ0FBQztBQUNwQyxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBRTVDLE1BQU0sYUFBYSxHQUFHLEdBQUcsQ0FBQztJQUN4QixPQUFPLEVBQUUsTUFBTTtJQUNmLGFBQWEsRUFBRSxRQUFRO0lBQ3ZCLEdBQUcsRUFBRSxNQUFNO0NBQ1osQ0FBQyxDQUFDO0FBRUgsTUFBTSxXQUFXLEdBQUcsR0FBRyxDQUFDO0lBQ3RCLFVBQVUsRUFBRSxxQkFBcUI7SUFDakMsUUFBUSxFQUFFLE1BQU07SUFDaEIsYUFBYSxFQUFFLFFBQVE7SUFDdkIsYUFBYSxFQUFFLFdBQVc7SUFDMUIsVUFBVSxFQUFFLE1BQU07SUFDbEIsS0FBSyxFQUFFLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSztJQUN6QixNQUFNLEVBQUUsR0FBRztJQUNYLFVBQVUsRUFBRSxNQUFNO0NBQ25CLENBQUMsQ0FBQztBQUVILE1BQU0saUJBQWlCLEdBQUcsR0FBRyxDQUFDO0lBQzVCLE1BQU0sRUFBRSxTQUFTO0lBQ2pCLEtBQUssRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLFNBQVM7SUFDN0IsVUFBVSxFQUFFLE1BQU07SUFDbEIsYUFBYSxFQUFFLFdBQVc7SUFDMUIsT0FBTyxFQUFFLEtBQUs7SUFDZCxRQUFRLEVBQUUsVUFBVTtJQUNwQixNQUFNLEVBQUUsR0FBRztJQUNYLFNBQVMsRUFBRTtRQUNULEtBQUssRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLFNBQVM7S0FDOUI7Q0FDRixDQUFDLENBQUM7QUFFSCxNQUFNLG1CQUFtQixHQUFHO0lBQzFCLE9BQU8sRUFBRSxNQUFNO0lBQ2YsY0FBYyxFQUFFLGVBQWU7SUFDL0IsR0FBRyxFQUFFLE1BQU07SUFDWCxNQUFNLEVBQUUsTUFBTTtDQUNmLENBQUM7QUFVRixNQUFNLFdBQVcsR0FBeUIsQ0FBQyxFQUN6QyxNQUFNLEVBQ04sU0FBUyxFQUNULFVBQVUsRUFDVixVQUFVLEVBQ1YsUUFBUSxHQUNULEVBQUUsRUFBRTtJQUNILE1BQU0sZUFBZSxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUMsTUFBTSxDQUFDO0lBRXZELE9BQU8sQ0FDTCw2QkFBSyxTQUFTLEVBQUUsYUFBYTtRQUMzQiw0QkFBSSxTQUFTLEVBQUUsV0FBVywyQkFBMkI7UUFFckQsNkJBQUssS0FBSyxFQUFFLG1CQUFtQjtZQUM3QixvQkFBQyxNQUFNLElBQ0wsTUFBTSxFQUFDLFlBQVksRUFDbkIsSUFBSSxFQUFFLFlBQVksZUFBZSw0QkFBNEIsR0FDN0Q7WUFFRCxlQUFlLEdBQUcsQ0FBQyxJQUFJLENBQ3RCLGdDQUNFLElBQUksRUFBQyxRQUFRLEVBQ2IsU0FBUyxFQUFFLGlCQUFpQixFQUM1QixPQUFPLEVBQUUsVUFBVSxnQkFHWixDQUNWLENBQ0c7UUFFTixvQkFBQyxXQUFXLElBQUMsR0FBRyxFQUFFLFFBQVEsRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxTQUFTLEdBQUksQ0FDaEUsQ0FDUCxDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsT0FBTyxFQUFFLFdBQVcsRUFBRSxDQUFDIn0=